import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import productsData from '../data/products.json';
import { optimizeImage } from '../utils/imageOptimizer';
import './CategoryProductsPage.css';

const CategoryProductsPage = () => {
    const { pet, category } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pet, category]);

    // Decode URL params just in case they have spaces
    const decodedCategory = decodeURIComponent(category || '');
    const formattedPet = pet === 'dog' ? 'Dogs' : 'Cats';

    const getHeadingText = () => {
        if (decodedCategory.toLowerCase() === 'biscuits') return `Healthy Biscuits for ${formattedPet}`;
        if (decodedCategory.toLowerCase() === 'dry foods') return `Premium Dry Foods for ${formattedPet}`;
        if (decodedCategory.toLowerCase() === 'cosmetics') return `Grooming & Cosmetics for ${formattedPet}`;
        if (decodedCategory.toLowerCase() === 'toppings') return `Delicious Toppings for ${formattedPet}`;
        if (decodedCategory.toLowerCase() === 'treats') return `Tasty Treats for ${formattedPet}`;
        if (decodedCategory.toLowerCase() === 'gravy') return `Delicious Gravy for ${formattedPet}`;
        if (decodedCategory.toLowerCase() === 'others') return `Other Products for ${formattedPet}`;
        return `${decodedCategory} for ${formattedPet}`;
    };

    // Filter products
    const filteredProducts = productsData.filter(
        prod => prod.type === pet && prod.category.toLowerCase() === decodedCategory.toLowerCase()
    );

    return (
        <div className="catpage-wrapper">
            <div className="catpage-container container">
                <h1 className="catpage-title">{getHeadingText()}</h1>

                {filteredProducts.length > 0 ? (
                    <div className={`catpage-grid ${filteredProducts.length === 4 ? 'cols-4' : ''}`}>
                        {filteredProducts.map(prod => (
                            <Link to={`/${prod.type}-products/${prod.id}`} key={prod.id} className="catpage-card">
                                <div className="catpage-card-img-wrap">
                                    <img 
                                        src={optimizeImage(prod.img, { width: 300, height: 300 })} 
                                        alt={prod.name} 
                                        className="catpage-card-img" 
                                        loading="lazy"
                                        width="300"
                                        height="300"
                                    />
                                    {prod.isComingSoon && (
                                        <div className="coming-soon-label">Coming Soon</div>
                                    )}
                                </div>
                                <div className="catpage-card-info">
                                    <h4 className="catpage-card-name">{prod.name}</h4>
                                    {!prod.isComingSoon && <p className="catpage-card-price">{prod.price}</p>}
                                </div>
                            </Link>
                        ))}
                    </div>
                ) : (
                    <div className="catpage-empty">
                        <p>No products found in this category.</p>
                        <Link to="/products" className="catpage-back-btn">View All Products</Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CategoryProductsPage;
